module.exports = __webpack_public_path__ + "static/media/medalla-letra-M_1.85b2854d.png";